import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

// Barra superior mínima visible en todas las páginas excepto Landing (/)
// Permite volver al inicio sin usar el botón atrás del navegador
function NavBar() {
  const navigate  = useNavigate();
  const location  = useLocation();

  // No mostrar en la landing ni en la pantalla de procesando
  if (location.pathname === '/' || location.pathname === '/procesando') return null;

  return (
    <motion.nav
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      style={{
        position:        'sticky',
        top:             0,
        zIndex:          100,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'space-between',
        padding:         '0.7rem 1.5rem',
        background:      'rgba(10,10,20,0.85)',
        backdropFilter:  'blur(12px)',
        borderBottom:    '1px solid rgba(255,215,0,0.12)',
      }}
    >
      {/* Logo / Inicio */}
      <button
        onClick={() => navigate('/')}
        style={{
          background:  'none',
          border:      'none',
          cursor:      'pointer',
          display:     'flex',
          alignItems:  'center',
          gap:         '0.5rem',
          color:       'var(--color-oro)',
          fontWeight:  '700',
          fontSize:    '1rem',
          padding:     '0.3rem 0',
          opacity:     0.9,
        }}
      >
        <span style={{ fontSize: '1.2rem' }}>🌙</span>
        <span>Tu Mano Dice</span>
      </button>

      {/* Botón volver — solo en /resultado */}
      {location.pathname === '/resultado' && (
        <button
          onClick={() => navigate('/lectura')}
          style={{
            background:    'rgba(255,215,0,0.08)',
            border:        '1px solid rgba(255,215,0,0.25)',
            borderRadius:  '20px',
            color:         'var(--color-texto-suave)',
            fontSize:      '0.78rem',
            padding:       '0.35rem 0.9rem',
            cursor:        'pointer',
          }}
        >
          Nueva lectura
        </button>
      )}
    </motion.nav>
  );
}

export default NavBar;
